import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { orderAPI } from '../api/services';
import './OrderDetail.css';

function OrderDetail() {
  const { id } = useParams();
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchOrder();
  }, [id]);

  const fetchOrder = async () => {
    setLoading(true);
    try {
      const response = await orderAPI.getOrder(id);
      setOrder(response.data);
    } catch (error) {
      console.error('Failed to fetch order', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="loading container mt">
        <div className="spinner"></div>
      </div>
    );
  }

  if (!order) {
    return (
      <div className="container mt">
        <p>Order not found</p>
      </div>
    );
  }

  const total = order.total_amount + order.tax_amount + order.shipping_amount;

  const getStatusSteps = () => {
    const steps = ['pending', 'confirmed', 'shipped', 'delivered'];
    return steps.map((step) => ({
      name: step.charAt(0).toUpperCase() + step.slice(1),
      completed: steps.indexOf(step) <= steps.indexOf(order.status),
    }));
  };

  return (
    <div className="order-detail-page">
      <div className="container">
        <Link to="/orders" className="back-link">← Back to Orders</Link>

        <h1>Order Details</h1>

        <div className="order-detail-layout">
          {/* Order Info */}
          <section className="order-info-card card">
            <div className="order-header">
              <div>
                <h2>Order #{order.id}</h2>
                <p className="order-date">Placed on {new Date(order.created_at).toLocaleDateString('en-PK', { timeZone: 'Asia/Karachi' })}</p>
              </div>
              <span className={`status-badge status-${order.status}`}>
                {order.status.charAt(0).toUpperCase() + order.status.slice(1)}
              </span>
            </div>

            {/* Status Timeline */}
            <div className="status-timeline">
              {getStatusSteps().map((step, index) => (
                <div key={step.name} className="timeline-step">
                  <div className={`timeline-dot ${step.completed ? 'completed' : ''}`}></div>
                  {index < getStatusSteps().length - 1 && (
                    <div className={`timeline-line ${step.completed ? 'completed' : ''}`}></div>
                  )}
                  <span className="timeline-label">{step.name}</span>
                </div>
              ))}
            </div>
          </section>

          {/* Order Items */}
          <section className="order-items-card card">
            <h2>Items Ordered</h2>
            <table className="items-table">
              <thead>
                <tr>
                  <th>Product</th>
                  <th>Price</th>
                  <th>Quantity</th>
                  <th>Subtotal</th>
                </tr>
              </thead>
              <tbody>
                {order.items.map((item) => (
                  <tr key={item.id}>
                    <td>{item.product_id}</td>
                    <td>Rs {item.price.toFixed(0)}</td>
                    <td>{item.quantity}</td>
                    <td>Rs {(item.price * item.quantity).toFixed(0)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </section>

          {/* Delivery Address */}
          <section className="delivery-card card">
            <h2>Delivery Address</h2>
            <p className="address">{order.delivery_address}</p>
            <p className="phone">📞 {order.phone}</p>
          </section>

          {/* Order Summary */}
          <section className="summary-card card">
            <h2>Order Summary</h2>
            <div className="summary-row">
              <span>Subtotal:</span>
              <span>Rs {order.total_amount.toFixed(0)}</span>
            </div>
            <div className="summary-row">
              <span>Tax (5%):</span>
              <span>Rs {order.tax_amount.toFixed(0)}</span>
            </div>
            <div className="summary-row">
              <span>Shipping:</span>
              <span>Rs {order.shipping_amount.toFixed(0)}</span>
            </div>
            <div className="summary-divider"></div>
            <div className="summary-row total">
              <span>Total Amount:</span>
              <span>Rs {total.toFixed(0)}</span>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}

export default OrderDetail;
